import type { MoMSalesReportResult } from './types';
import { downloadExcelWorkbook } from '../reports/exportExcelWorkbook';

const fileName = () => `MoM_Sales_Report_${new Date().toISOString().slice(0, 10)}.xlsx`;

export const exportMoMSalesReport = async (report: MoMSalesReportResult): Promise<void> => {
  const { default: ExcelJS } = await import('exceljs');
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('MoM Sales Report');

  worksheet.columns = [
    { header: 'Client', key: 'clientName', width: 35 },
    { header: `${report.basePeriodCaption} (Base Period)`, key: 'basePeriodSalesUsd', width: 24 },
    {
      header: `${report.reportingPeriodCaption} (Reporting Period)`,
      key: 'reportingPeriodSalesUsd',
      width: 28,
    },
    { header: 'Variance, USD', key: 'varianceUsd', width: 18 },
    { header: 'Variance, %', key: 'variancePercentDisplay', width: 16 },
  ];
  worksheet.getRow(1).font = { bold: true };

  report.rows.forEach((row) => {
    const worksheetRow = worksheet.addRow(row);
    if (row.isTotal) worksheetRow.font = { bold: true };
  });

  const buffer = await workbook.xlsx.writeBuffer();
  downloadExcelWorkbook(buffer, fileName());
};
